export default __webpack_public_path__ + "static/media/v8.a1eca2aa.jpg";